import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@mantine/core';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getScheduledActivityListQuery } from '../../../../slices/scheduledActivity/thunk';

// "YYYY-MM" of today — used to include only the current month's Programado entries
const getCurrentPeriod = () => {
	const now = new Date();
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0');
	return `${year}-${month}`;
};

const getReportabilityStatusColor = name => {
	if (!name) return 'gray';
	switch (name) {
		case 'Programado':                return 'blue';
		case 'Reportado':                 return 'green';
		case 'Fuera de Plazo':            return 'yellow';
		case 'Atrasado':                  return 'red';
		case 'En espera de resultados':   return 'cyan';
		case 'Pendiente':                 return 'cyan';
		default:                          return 'gray';
	}
};

const formatDateTime = dateString => {
	if (!dateString) return '-';
	const date = new Date(dateString);
	if (isNaN(date.getTime())) return '-';
	const day   = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const year  = date.getFullYear();
	const hh    = String(date.getHours()).padStart(2, '0');
	const mm    = String(date.getMinutes()).padStart(2, '0');
	return `${day}/${month}/${year} ${hh}:${mm}`;
};

const ActivitiesDashboardGrid = () => {
	const currentPeriod = useMemo(() => getCurrentPeriod(), []);

	const columns = useMemo(() => [
		// {
		// 	header: 'Acción',
		// 	enableSorting: false,
		// 	enableColumnFilter: false,
		// 	enableGlobalFilter: false,
		// 	enableColumnActions: false,
		// 	accessorKey: 'actions',
		// 	columnDefType: 'display',
		// 	size: 'auto',
		// 	Cell: ({ row }) => {
		// 		const activityData = row.original;
		// 		const statusName = activityData.activity_status?.name;
		// 		const isProgramado = statusName === 'Programado';

		// 		return (
		// 			<div className='d-flex'>
		// 				<div className='flex-shrink-0'>
		// 					<ul className='list-inline mb-0'>
		// 						<li className='list-inline-item'>
		// 							<Link
		// 								title='Ver Actividad'
		// 								to='#'
		// 								// className={isProgramado ? 'text-muted pe-none opacity-50' : 'text-success'}
		// 								onClick={e => {
		// 									e.preventDefault();
		// 									if (isProgramado) return;
		// 									// TODO: Implementar descarga de Excel
		// 								}}
		// 							>
		// 								<i className='icon-search align-bottom'></i>
		// 							</Link>
		// 						</li>
		// 					</ul>
		// 				</div>
		// 			</div>
		// 		);
		// 	},
		// },
		{
			header: 'Estado',
			dataType: 'select',
			accessorKey: 'activity_status.name',
			Cell: cellProps => {
				const name = cellProps.row.original.activity_status?.name;
				return (
					<Badge color={getReportabilityStatusColor(name)} tt='capitalize'>
						{name || '-'}
					</Badge>
				);
			},
		},
		{
			header: 'Establecimiento',
			dataType: 'select',
			accessorKey: 'establishment_name',
		},
		{
			header: 'Código de Obra',
			dataType: 'string',
			accessorKey: 'work_order.work_order_code',
		},
		{
			header: 'Fecha Reportabilidad',
			dataType: 'date',
			defaultSort: 'desc',
			accessorKey: 'reporting_date',
		},
		{
			header: 'Periodo',
			dataType: 'date',
			accessorKey: 'period',
		},
		{
			header: 'Fecha Hora Reporte',
			dataType: 'datetime',
			accessorKey: 'report_datetime',
			Cell: cellProps => {
				return <span>{formatDateTime(cellProps.row.original.report_datetime)}</span>;
			},
		},
		{
			header: 'Usuario Responsable',
			dataType: 'string',
			accessorKey: 'report_user_info.full_name',
		},
	], []);

	return (
		<ODataGrid
			columns={columns}
			getDataFunc={getScheduledActivityListQuery}
			baseFilters={{
				period: { $lte: currentPeriod },
				disable: { $eq: false },
			}}
			remoteOperations={{ pagination: true, sorting: true, filtering: true }}
			queryPopulate={['activity_status', 'work_order', 'report_user']}
			defaultPageSize={25}
			nameFile='actividades_dashboard'
			getRowIdTable={row => row._id}
		/>
	);
};

export default ActivitiesDashboardGrid;


